import React from 'react';

// Headings, bold, bullets and rules: the Markdown the Studio's flyer and blog prompts produce.
// Builds React elements (no innerHTML), so generated text can never inject markup.
const inline = (text) =>
  text.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
    part.startsWith('**') && part.endsWith('**') && part.length > 4
      ? <strong key={i}>{part.slice(2, -2)}</strong>
      : part
  );

const HEADING = { 1: 'text-xl font-bold mt-1', 2: 'text-lg font-bold mt-3', 3: 'text-base font-semibold mt-3' };

export default function SimpleMarkdown({ text }) {
  const blocks = [];
  let bullets = [];
  const flush = () => {
    if (bullets.length) {
      blocks.push(<ul key={`ul${blocks.length}`} className="list-disc pl-5 space-y-1">{bullets}</ul>);
      bullets = [];
    }
  };
  (text || '').split('\n').forEach((raw, idx) => {
    const line = raw.trim();
    const bullet = line.match(/^[-*]\s+(.*)$/);
    if (bullet) { bullets.push(<li key={idx}>{inline(bullet[1])}</li>); return; }
    flush();
    if (!line) return;
    const heading = line.match(/^(#{1,6})\s+(.*)$/);
    if (heading) {
      const level = Math.min(heading[1].length, 3);
      blocks.push(<div key={idx} className={HEADING[level]} role="heading" aria-level={heading[1].length}>{inline(heading[2])}</div>);
    } else if (/^(-{3,}|\*{3,})$/.test(line)) {
      blocks.push(<hr key={idx} className="my-3 border-slate-200" />);
    } else {
      blocks.push(<p key={idx}>{inline(line)}</p>);
    }
  });
  flush();
  return <div className="space-y-2">{blocks}</div>;
}
